import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest);

export async function getLanguageSettings(langaugeId:string): any {
    return http.get(`admin/languages/${langaugeId}/settings`)
}